<template>
  <div id="app" class="min-h-screen">
    <!-- 使用布局的页面 -->
    <MainLayout v-if="!route.meta.hiddenLayout">
      <router-view />
    </MainLayout>
    
    <!-- 不使用布局的页面（如登录页） -->
    <router-view v-else />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'

const route = useRoute()
</script>

<style>
/* 全局样式在global.css中定义 */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
    